<!-- 処理後物一覧 -->
<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">mdi-recycle</v-icon>
          処理後物
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row>
    <!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">mdi-magnify</v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="conditions.code"
                        dense
                        hide-details
                        label="コード"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="conditions.code = null; searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-checkbox
                        v-model="conditions.without_invisible"
                        label="非表示を表示しない"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-card-actions class="mt-2 mb-5">
      <v-btn-toggle
        v-model="conditions.after_type"
        class="toggleButton"
        color="info accent-3"
        tile
        light
        mandatory
        rounded
        @change="menuChangeEvent"
      >
        <v-btn
          value="after_industrial"
          width="140"
        >
          廃棄物
        </v-btn>
        <v-btn
          value="after_recycling"
          width="140"
        >
          再資源
        </v-btn>
      </v-btn-toggle>
      <v-spacer />
      <v-btn color="info" @click="exportButtonClickEvent">
        <v-icon>mdi-file-download-outline</v-icon>&nbsp;CSV出力
      </v-btn>
      &nbsp;
      <v-btn color="info" @click="importButtonClickEvent">
        <v-icon>mdi-file-upload-outline</v-icon>&nbsp;CSV取込
      </v-btn>
      &nbsp;
      <v-btn color="primary" @click="addButtonClickEvent">
        新規追加&nbsp;<v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-sheet class="mt-5 mb-5" rounded>
      <v-data-table
        :headers="tableHeaders"
        :items="recycleDisposedItems"
        disable-pagination
        :items-per-page="-1"
        disable-sort
        hide-default-footer
      >
        <template v-slot:[`item.invisible`]="{ item }">
          <span v-if="item.invisible">非表示</span>
        </template>

        <template v-slot:[`item.updated_at`]="{ item }">
          {{ item.updated_at | unix_datetime_format }}
        </template>

        <template v-slot:[`item.editable`]="{ item }">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="editButtonClickEvent(item)">
                <v-list-item-title> 編集 </v-list-item-title>
              </v-list-item>
              <v-list-item @click="showButtonClickEvent(item)">
                <v-list-item-title> 詳細 </v-list-item-title>
              </v-list-item>
              <v-list-item @click="duplicateButtonClickEvent(item)">
                <v-list-item-title> 複写して細分類を作成 </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-sheet>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <after-disposed-item-modal
      :enable="enableAfterDisposedItemModal"
      :after_type="conditions.after_type"
      @close="closeRecycleDisposedItemDialog"
      @register="recycleDisposedItemCallback"
    />

    <recycle-disposed-item-modal
      :enable-dialog="enableRegistModal"
      :after-type="conditions.after_type"
      :target-id="targetId"
      :duplicate="duplicate"
      :read-only="readOnly"
      @close="closeRecycleDisposedItemDialog"
      @register="recycleDisposedItemCallback"
    />

    <recycle-disposed-item-show-dialog
      :enable-dialog="enableRecycleDisposedItemShowDialog"
      :target-id="targetId"
      @close="closeRecycleDisposedItemDialog"
      @register="recycleDisposedItemCallback"
      @edit="editCallback"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import CustomPagination from '@/driver/components/_CustomPagination.vue'
import RecycleDisposedItemShowDialog from './dialogs/RecycleDisposedItemShowDialog.vue'
import DownloadMixin from '../../../../mixins/download-mixin'
import AfterDisposedItemModal from "@/driver/pages/masters/recycle_disposed_items/dialogs/AfterDisposedItemModal.vue";
import RecycleDisposedItemModal
  from "@/driver/pages/masters/recycle_disposed_items/dialogs/RecycleDisposedItemModal.vue";

export default {
  name: 'DriverMasterRecycleDisposedItems',
  components: {
    RecycleDisposedItemModal,
    AfterDisposedItemModal,
    CustomPagination,
    RecycleDisposedItemShowDialog,
  },
  mixins: [DownloadMixin],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      targetId: null,
      duplicate: false,
      readOnly: false,
      enableRegistModal: false,
      enableRecycleDisposedItemShowDialog: false,
      enableAfterDisposedItemModal: false,
      conditions: {
        after_type: 'after_industrial',
        code: null,
        without_invisible: true,
      },
      pagination: {
        current_page: 1,
        total_count: 0
      },
      recycleDisposedItems: [],
      tableHeaders: [
        { value: 'code', text: 'コード', width: "8%" },
        { value: 'after_type_name', text: '種別', width: "8%" },
        { value: 'major_name', text: '処理後物の大分類', width: "24%" },
        { value: 'subclass_name', text: '処理後物の種類', width: "28%" },
        { value: 'sort_priority', text: '表示順', align: 'right', width: "8%" },
        { value: 'invisible', text: '非表示', align: 'center', width: "8%" },
        { value: 'updated_at', text: 'データ更新日時', width: "8%" },
        { value: 'editable', text: '詳細・編集', align: 'end', width: "8%" },
      ],
    }
  },
  computed: {
  },
  created () {
    this.searchRecycleDisposedItems()
  },
  methods: {
    ...mapActions('DriverMasterRecycleDisposedItem', {
      fetchRecycleDisposedItems: 'index',
    }),

    editButtonClickEvent (item) {
      this.targetId = item.id;
      this.duplicate = false;
      this.readOnly = false;
      this.enableRegistModal = true;
    },

    showButtonClickEvent (item) {
      this.targetId = item.id;
      this.duplicate = false;
      this.readOnly = true;
      this.enableRecycleDisposedItemShowDialog = true;
    },

    duplicateButtonClickEvent (item) {
      this.targetId = item.id;
      this.duplicate = true;
      this.readOnly = false;
      this.enableRegistModal = true;
    },

    searchButtonClickEvent () {
      this.page = 1
      this.searchRecycleDisposedItems()
    },
    changePage (page) {
      this.page = page
      this.searchRecycleDisposedItems()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchRecycleDisposedItems()
    },
    /**
     * トグルボタン クリックイベント
     */
    menuChangeEvent () {
      this.searchButtonClickEvent()
    },
    addButtonClickEvent () {
      this.targetId = null
      this.enableAfterDisposedItemModal = true
    },

    closeRecycleDisposedItemDialog () {
      this.enableRegistModal = false
      this.enableRecycleDisposedItemShowDialog = false
      this.enableAfterDisposedItemModal = false
    },
    /**
     * 詳細モーダルから編集モーダルへ遷移コールバック
     */
    editCallback () {
      this.enableRecycleDisposedItemShowDialog = false;
      this.enableRegistModal = true;
    },
    recycleDisposedItemCallback () {
      this.closeRecycleDisposedItemDialog()
      this.searchRecycleDisposedItems()
    },
    exportButtonClickEvent () {
      this.fetchRecycleDisposedItems(this.buildParam('csv')).then((data) => {
        this.downloadCsv(data, "処理後物")
      })
    },
    importButtonClickEvent () {
      this.$router.push({ name: 'DriverMasterRecycleDisposedItemCsvImport' })
    },
    searchRecycleDisposedItems () {
      this.fetchRecycleDisposedItems(this.buildParam('json')).then((content) => {
        this.recycleDisposedItems = content.recycle_disposed_items;
        this.pagination = content.pagination;
      })
    },
    buildParam (format) {
      return {
        ...this.conditions,
        page: this.page,
        limit: this.perPage,
        format: format,
      }
    },
  },
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}
</style>
